import { useMutation, useQueryClient } from 'react-query';
import { generatePadiDocumentsAPIWithTravelerId } from '../utilities/app-utilities';
import { useApi } from '../contexts/api-context';
import { useModal } from '../hooks/useModal';
import { useTravelerId } from '../hooks/useTravelerId';
import { useDrawer } from '../hooks/useDrawer';

export function usePadiSpecialDocumentUpload() {
    const { PadiAPI } = useApi();
    const { travelerId } = useTravelerId();
    const { closeModal } = useModal();
    const queryClient = useQueryClient();
    const { closeDrawer } = useDrawer();

    // @ts-ignore - need to update how the api service itself is built to fix this.
    return useMutation(PadiAPI.uploadSpecialDocumentRequirement, {
        enabled: !!PadiAPI && travelerId,
        onSuccess: () => {
            closeDrawer();
            closeModal();
        },
        // Always refetch after error or success:
        onSettled: () => {
            queryClient.invalidateQueries(generatePadiDocumentsAPIWithTravelerId(travelerId)); // set documents to be refetched after a successful reset
        },
    });
}
